import { render } from "./Itens.vue?vue&type=template&id=2e71b5f8&scoped=true"
import script from "./Itens.vue?vue&type=script&lang=js"
export * from "./Itens.vue?vue&type=script&lang=js"

import "./Itens.vue?vue&type=style&index=0&id=2e71b5f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e71b5f8"]])

export default __exports__